// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"s8-z"};